
import { makeStyles } from 'tss-react/mui';

type StyleProps = {
  fullWidth: boolean;
};

export const useContextualNavigationStyles = makeStyles<StyleProps>({ name: 'ContextualNavigationLayout' })((theme, { fullWidth }) => ({
  contentRoot: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
  },
  header: {
    alignItems: 'center',
    background: '#fff',
    boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, .12)',
    color: theme.palette.text.primary,
    display: 'flex',
    height: '62px',
    margin: fullWidth ? 0 : 'auto',
    maxWidth: fullWidth ? '100%' : '1440px',
    minHeight: '62px',
    width: '100%',
    zIndex: 1000,
  },
  headerWrapper: {
    background: '#fff',
    boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, .12)',
    flex: 0,
    height: '62px',
  },
  headerButton: {
    padding: 0,
  },
  logo: {
    display: 'flex',
    justifyContent: 'center',
    '& svg path': {
      fill: theme.palette.darkSlate.main
    }
  },
  root: {
    color: theme.palette.text.primary,
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
  },
}));
